export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const GOOGLE_REGISTER_SUCCESS = "GOOGLE_REGISTER_SUCCESS";
export const GOOGLE_REGISTER_FAILED = "GOOGLE_REGISTER_FAILED";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const UPLOAD_DOCUMENT_SUCCESS = "UPLOAD_DOCUMENT_SUCCESS";
export const UPLOAD_DOCUMENT_FAIL = "UPLOAD_DOCUMENT_FAIL";
export const UPDATE_SUCCESS = "UPDATE_SUCCESS";
export const UPDATE_FAIL = "UPDATE_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const GOOGLE_LOGIN_SUCCESS = "GOOGLE_LOGIN_SUCCESS";
export const GOOGLE_LOGIN_FAILED = "GOOGLE_LOGIN_FAILED";
export const LOGOUT = "LOGOUT";
export const BRICKS_SELLED_SUCCESS = "BRICKS_SELLED_SUCCESS"
export const BRICKS_SELLED_FAIL = "BRICKS_SELLED_FAIL"
export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
export const INFORMATION_UPDATED = "INFORMATION_UPDATED"
export const INFORMATION_UPDATE_FAILED = "INFORMATION_UPDATE_FAILED"